var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-15"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',[_vm._v("Страница не найдена")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }